import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopictwo/Gondola_2.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Gondola extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Jugo_43 = gltf.scene.getObjectByName("Jugo_43", true);
			this.Jugo_12 = gltf.scene.getObjectByName("Jugo_26", true);
			this.Suero_1 = gltf.scene.getObjectByName("Suero_1", true);
			this.cafe_2 = gltf.scene.getObjectByName("cafe_2", true);

			this.Refresco_22001 = gltf.scene.getObjectByName("Refresco_22001", true);
			this.Refresco_22 = gltf.scene.getObjectByName("Refresco_22", true);
			this.Gatorade_1001 = gltf.scene.getObjectByName("Gatorade_1001", true);
			this.Gatorade_1 = gltf.scene.getObjectByName("Gatorade_1", true);
			this.Jugo_36001 = gltf.scene.getObjectByName("Jugo_36001", true);
			this.Jugo_36 = gltf.scene.getObjectByName("Jugo_36", true);
			this.Jugo_23001 = gltf.scene.getObjectByName("Jugo_23001", true);
			this.Jugo_23 = gltf.scene.getObjectByName("Jugo_23", true);

			this.positionAllObject = {
				Jugo_43: this.Jugo_43.position.clone(),
				Jugo_12: this.Jugo_12.position.clone(),
				Suero_1: this.Suero_1.position.clone(),
				cafe_2: this.cafe_2.position.clone(),
				Refresco_22001: this.Refresco_22001.position.clone(),
				Refresco_22: this.Refresco_22.position.clone(),
				Gatorade_1001: this.Gatorade_1001.position.clone(),
				Gatorade_1: this.Gatorade_1.position.clone(),
				Jugo_36001: this.Jugo_36001.position.clone(),
				Jugo_36: this.Jugo_36.position.clone(),
				Jugo_23001: this.Jugo_23001.position.clone(),
				Jugo_23: this.Jugo_23.position.clone(),
			}
		});
	}

	positionInitAll() {
		Object.entries(this.positionAllObject).forEach(([key, value]) => {
			this[key].position.copy(value);
		})
	}


	onStatusActivityTwo() {
		this.Jugo_43.position.set(29, 155.1219, 44.8436);
		this.Jugo_12.position.set(17, 166.1497, 55.8715);
		this.Suero_1.position.set(28, 166.1497, 50);
		this.cafe_2.position.set(17, 155.1219, 44);
	}

	statusActvTwoFondeo() {
		this.Jugo_23001.position.set(20, 140, -10.2955);
		this.Jugo_36001.position.set(31, 146, -13);
		this.Refresco_22001.position.set(22.788, 147, 0.7323);
		this.Gatorade_1001.position.set(15, 144, 0.7323);
	}

	onAnimate(object) {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissiveIntensity = 1
			this.objectActiveAnimation = null
		}

		if (!object) {
			return
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.objectActiveAnimation = object
		// object.material.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}


	helperObjectGeneral() {
		const gui = new GUI();
		const folferMostrador = gui.addFolder("Gondola");
		const limit = 20;
		folferMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(this, "visible").name("Visible");
	}

	helpersChild() {
		// this.helperMethod("Cubeta", this.Cubeta);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
